import { useContext } from "react";
import MenuContext from "@contexts/MenuContext";

export const useMenuToggle = () => {
 return useContext(MenuContext);
};
